export default __webpack_public_path__ + "static/media/list_milita_1.8e765190.png";